import { gql } from '@apollo/client';

export const VEHICLE_DETAILS = gql`
  query getVehicleInfoForWormwood(
    $market: MarketType!
    $lang: String!
    $id: String!
    $version: String
  ) {
    getVehicleInfoForWormwood(market: $market, lang: $lang, id: $id, version: $version) {
      modelName
      trimName
      bodyType
      modelYear
      trimline
      modelPrice
      saleOrderType
      vehicleOrderStatus
      vin
      stockNumber
      isAvailableNow
      kvpsSyncId
      vehicleInventoryType
      gearType
      driveType
      modelMileage
      vehicleType
      market
      fuelType
      vehicleHistoryReports {
        source
        url
      }
      equipments {
        optionalEquipments {
          headline
          text
          imageUrl
          benefits
        }
        standardEquipments {
          interior {
            headline
            text
            imageUrl
          }
          exterior {
            headline
            text
            imageUrl
          }
          assistanceSystems {
            headline
            text
            imageUrl
          }
          technology {
            headline
            text
            imageUrl
          }
          trimsAndPackages {
            headline
            text
            imageUrl
          }
          performance {
            headline
            text
            imageUrl
          }
        }
      }
      exteriorColor
      upholsteryColor
      interiorTileImage
      exteriorTileImage
      dealerName
      dealerNote
      staticDealerInfo {
        isDealerNoteVisible
        mapImage
        dagid
      }
      vehicleMedia {
        mediaRequestString
        mediaImages {
          config
          imageType
          url
        }
      }
      technicalSpecifications {
        engineType
        displacement
        maxOutput
        maxTorque
        gearbox
        frontAxle
        rearAxle
        brakes
        steering
        unladenWeight
        grossWeightLimit
        tankCapacity
        luggageCompartmentCapacity
        topSpeed
        acceleration
        fuelType
        fuelData {
          fuel_petrol {
            unit
            urban
            extraUrban
            combined
          }
          fuel_electrical {
            unit
            urban
            extraUrban
            combined
          }
        }
      }
    }
  }
`;

export const GET_FILTERED_VEHICLES = gql`
  query getFilteredVehiclesForWormwood(
    $version: String
    $market: [MarketType]!
    $limit: Int
    $lang: String!
    $filters: String
    $ranges: String
    $sort: String
    $offset: Int
    $preset: String
  ) {
    getFilteredVehiclesForWormwood(
      version: $version
      market: $market
      size: $limit
      lang: $lang
      filters: $filters
      ranges: $ranges
      sort: $sort
      from: $offset
      preset: $preset
    ) {
      filterResults {
        totalCount
      }
      vehicles {
        vin
        id
      }
    }
  }
`;
